var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:[
    'common-header-wrapper',
    'flex-col-center',
    _vm.type,
    _vm.fissionGame,
    _vm.displayLayout,
  ]},[(_vm.type === 'isOwner')?[_c('p',{staticClass:"title flex-center"},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"notice-wrapper"},[_c('van-notice-bar',{attrs:{"scrollable":false,"wrapable":""}},[_c('van-swipe',{staticClass:"score-swipe",attrs:{"vertical":"","autoplay":1500,"show-indicators":false,"touchable":false}},_vm._l((_vm.dataSource),function(item,index){return _c('van-swipe-item',{key:index},[_vm._v(_vm._s(item)+"\n          ")])}),1)],1)],1)]:[_c('p',{staticClass:"title flex-center"},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v("\n      "+_vm._s(_vm.desc)+"\n    ")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }